<template>
  <a
    class="appstore__link"
    :class="{ 'appstore__link--disabled': disabled }"
    target="_blank"
    rel="noopener"
    :href="href"
    @click="$emit('close')">
    <!-- eslint-disable -->
    <svg
      class="appstore__img"
      viewBox="0 0 112 40"
      :class="{ 'appstore__img--big': isBig }">
      <path fill="currentColor" d="M26.9 20.62c-.01-2.46 2.02-3.65 2.11-3.7a4.53 4.53 0 0 0-3.56-1.94c-1.5-.15-2.96.9-3.72.9-.78 0-1.96-.88-3.22-.86a4.75 4.75 0 0 0-4 2.44c-1.73 3-.44 7.39 1.22 9.8.83 1.19 1.8 2.51 3.06 2.46 1.24-.05 1.7-.79 3.2-.79 1.48 0 1.91.8 3.2.76 1.33-.02 2.17-1.19 2.97-2.38a9.79 9.79 0 0 0 1.35-2.76 4.27 4.27 0 0 1-2.6-3.93ZM24.47 13.4a4.35 4.35 0 0 0 1-3.12c-.97.04-2.18.66-2.87 1.48a4.14 4.14 0 0 0-1.02 3c1.08.08 2.2-.55 2.89-1.37ZM46.08 28.02h-1.73l-.95-2.98h-3.3l-.9 2.98h-1.69l3.27-10.15h2.02l3.28 10.15Zm-2.97-4.23-.85-2.65c-.1-.27-.26-.9-.52-1.91h-.03l-.48 1.91-.84 2.65h2.72ZM54.48 24.27c0 1.25-.34 2.23-1.01 2.95-.6.64-1.35.96-2.24.96-.97 0-1.66-.34-2.08-1.03h-.03V31h-1.63v-7.89c0-.78-.02-1.58-.06-2.4h1.43l.1 1.15h.02a2.7 2.7 0 0 1 2.47-1.3c.87 0 1.59.33 2.16 1.02.58.68.87 1.58.87 2.7Zm-1.66.06c0-.71-.16-1.3-.48-1.76a1.66 1.66 0 0 0-1.41-.72c-.4 0-.77.13-1.1.4-.32.26-.53.61-.63 1.04-.06.2-.08.37-.08.5V25c0 .53.16.98.49 1.35.33.36.75.55 1.27.55.61 0 1.09-.24 1.43-.71.34-.47.51-1.1.51-1.87ZM62.9 24.27c0 1.25-.34 2.23-1.02 2.95-.6.64-1.35.96-2.24.96-.96 0-1.65-.34-2.08-1.03h-.03V31h-1.62v-7.89c0-.78-.02-1.58-.06-2.4h1.43l.09 1.15h.03a2.7 2.7 0 0 1 2.47-1.3c.86 0 1.58.33 2.16 1.02.57.68.86 1.58.86 2.7Zm-1.66.06c0-.71-.16-1.3-.49-1.76a1.66 1.66 0 0 0-1.41-.72c-.4 0-.77.13-1.1.4-.32.26-.53.61-.63 1.04-.05.2-.08.37-.08.5V25c0 .53.17.98.5 1.35.32.36.74.55 1.27.55.6 0 1.08-.24 1.42-.71.35-.47.52-1.1.52-1.87ZM72.3 25.17c0 .87-.3 1.57-.9 2.11a4 4 0 0 1-2.76.89c-1.1 0-1.97-.21-2.63-.63l.37-1.36c.72.43 1.5.65 2.35.65.61 0 1.1-.14 1.43-.41.34-.28.51-.65.51-1.11 0-.41-.14-.76-.42-1.04a3.92 3.92 0 0 0-1.4-.79c-1.77-.66-2.66-1.63-2.66-2.9 0-.84.31-1.52.93-2.06.62-.53 1.45-.8 2.49-.8.92 0 1.69.17 2.3.49l-.4 1.32a4 4 0 0 0-1.95-.46c-.57 0-1.02.14-1.34.42-.27.25-.4.55-.4.92 0 .4.15.73.46.99.27.24.76.5 1.48.78a5 5 0 0 1 1.92 1.24c.41.46.62 1.05.62 1.75ZM77.67 21.92h-1.79v3.56c0 .9.32 1.35.95 1.35.3 0 .53-.03.72-.08L77.6 28c-.32.12-.74.18-1.27.18-.64 0-1.14-.2-1.5-.59-.36-.39-.54-1.05-.54-1.97v-3.69h-1.07V20.7h1.07v-1.34l1.6-.48v1.82h1.78v1.22ZM85.76 24.3c0 1.13-.32 2.05-.97 2.77a3.44 3.44 0 0 1-2.68 1.11 3.27 3.27 0 0 1-2.56-1.06 3.89 3.89 0 0 1-.96-2.7c0-1.13.33-2.06.99-2.78a3.41 3.41 0 0 1 2.65-1.09c1.08 0 1.94.36 2.6 1.07.62.7.93 1.59.93 2.68Zm-1.69.05c0-.67-.14-1.25-.44-1.73a1.6 1.6 0 0 0-1.45-.88c-.66 0-1.15.3-1.5.88-.29.48-.43 1.07-.43 1.76 0 .68.14 1.26.44 1.74.35.58.84.87 1.47.87.62 0 1.1-.3 1.46-.89.3-.49.45-1.07.45-1.75ZM91.04 22.13a2.82 2.82 0 0 0-.51-.04c-.57 0-1.02.21-1.33.65-.27.38-.4.86-.4 1.44v3.84h-1.63L87.2 23c0-.85-.02-1.61-.06-2.3h1.41l.06 1.4h.05c.17-.49.44-.87.8-1.16.37-.27.76-.4 1.18-.4.15 0 .29.01.41.03v1.55ZM98.3 24.02c0 .29-.01.53-.05.73h-4.88c.02.73.26 1.28.71 1.66.41.34.94.51 1.6.51a5.4 5.4 0 0 0 1.97-.35l.25 1.13c-.69.3-1.5.46-2.45.46a3.55 3.55 0 0 1-2.67-1 3.7 3.7 0 0 1-.97-2.7c0-1.1.3-2.01.9-2.75a3.11 3.11 0 0 1 2.56-1.17c1.05 0 1.85.4 2.4 1.17.42.62.64 1.4.64 2.3Zm-1.54-.43c.01-.48-.1-.9-.32-1.25a1.42 1.42 0 0 0-1.3-.67c-.52 0-.96.22-1.29.66-.27.35-.43.77-.48 1.26h3.39ZM42.58 11.63c0 .9-.27 1.58-.81 2.03-.5.42-1.2.63-2.12.63-.46 0-.84-.02-1.17-.06v-4.9c.42-.07.88-.1 1.38-.1.87 0 1.53.18 1.97.56.5.43.75 1.04.75 1.84Zm-.85.02c0-.58-.15-1.02-.46-1.33-.3-.31-.76-.47-1.35-.47-.25 0-.46.02-.64.05v3.73l.54.02c.61 0 1.08-.17 1.41-.5.34-.35.5-.84.5-1.5ZM47.04 12.42c0 .55-.15 1-.47 1.36-.33.36-.77.54-1.32.54A1.6 1.6 0 0 1 44 13.8c-.31-.35-.47-.8-.47-1.32 0-.56.16-1.02.49-1.37.32-.36.76-.53 1.3-.53.53 0 .95.17 1.28.52.3.34.45.78.45 1.32Zm-.83.02c0-.33-.07-.61-.21-.85a.79.79 0 0 0-.72-.43.8.8 0 0 0-.73.43c-.14.24-.21.52-.21.87 0 .33.07.61.21.85a.8.8 0 0 0 .73.43c.3 0 .54-.15.71-.44.15-.24.22-.53.22-.86ZM53.03 10.65l-1.12 3.6h-.73l-.47-1.57c-.12-.39-.21-.77-.29-1.16h-.01c-.07.4-.17.78-.3 1.16l-.49 1.56h-.74l-1.05-3.6h.82l.4 1.72c.1.4.18.79.25 1.15h.01c.06-.3.16-.68.3-1.14l.5-1.72h.66l.49 1.68c.12.4.21.8.29 1.18h.02c.05-.37.13-.76.24-1.18l.44-1.68h.78ZM57.17 14.24h-.8v-2.06c0-.63-.24-.95-.72-.95a.72.72 0 0 0-.58.26.93.93 0 0 0-.22.62v2.13h-.8v-2.56c0-.32 0-.66-.03-1.03h.7l.04.56h.03c.09-.18.23-.32.41-.43.22-.14.46-.2.72-.2.34 0 .62.1.84.32.28.27.41.66.41 1.19v2.15ZM59.38 14.24h-.8V9h.8v5.24ZM64.08 12.42c0 .55-.16 1-.47 1.36a1.7 1.7 0 0 1-1.32.54 1.6 1.6 0 0 1-1.26-.52c-.31-.35-.47-.8-.47-1.32 0-.56.16-1.02.49-1.37.32-.36.75-.53 1.3-.53.53 0 .95.17 1.27.52.3.34.46.78.46 1.32Zm-.83.02c0-.33-.07-.61-.21-.85a.79.79 0 0 0-.72-.43.8.8 0 0 0-.73.43c-.14.24-.22.52-.22.87 0 .33.08.61.22.85a.8.8 0 0 0 .72.43c.3 0 .55-.15.72-.44.15-.24.22-.53.22-.86ZM67.95 14.24h-.72l-.06-.41h-.02c-.25.33-.6.5-1.05.5-.34 0-.61-.11-.82-.33-.19-.2-.28-.44-.28-.73 0-.44.18-.78.55-1 .37-.24.88-.35 1.55-.35v-.07c0-.47-.25-.7-.75-.7-.35 0-.66.08-.93.26l-.17-.52c.34-.21.75-.31 1.24-.31.93 0 1.4.5 1.4 1.48v1.33c0 .35.02.64.06.85Zm-.83-1.23v-.56c-.88-.01-1.32.23-1.32.73 0 .19.05.33.15.42.1.1.23.14.39.14a.8.8 0 0 0 .49-.17.68.68 0 0 0 .29-.56ZM72.49 14.24h-.71l-.04-.57h-.02c-.23.43-.61.65-1.16.65-.43 0-.79-.17-1.07-.5a1.99 1.99 0 0 1-.43-1.33c0-.58.15-1.05.46-1.41.3-.34.67-.5 1.11-.5.48 0 .82.16 1.01.48h.02V9h.8v4.27c0 .35 0 .68.03.97Zm-.83-1.51v-.6c0-.1 0-.19-.02-.25a.91.91 0 0 0-.3-.49.78.78 0 0 0-.53-.2c-.3 0-.53.12-.7.36-.17.24-.25.54-.25.91 0 .36.08.64.24.87.17.23.4.35.7.35.26 0 .47-.1.63-.3.15-.18.23-.4.23-.65ZM79.32 12.42c0 .55-.16 1-.47 1.36-.33.36-.77.54-1.32.54a1.6 1.6 0 0 1-1.26-.52c-.31-.35-.47-.8-.47-1.32 0-.56.16-1.02.48-1.37.33-.36.76-.53 1.31-.53.53 0 .95.17 1.27.52.3.34.46.78.46 1.32Zm-.83.02c0-.33-.07-.61-.21-.85a.79.79 0 0 0-.72-.43.8.8 0 0 0-.73.43c-.14.24-.22.52-.22.87 0 .33.08.61.22.85a.8.8 0 0 0 .72.43c.3 0 .55-.15.72-.44.15-.24.22-.53.22-.86ZM83.62 14.24h-.8v-2.06c0-.63-.24-.95-.73-.95a.72.72 0 0 0-.57.26.92.92 0 0 0-.22.62v2.13h-.8v-2.56l-.03-1.03h.7l.04.56h.02c.1-.18.23-.32.41-.43.22-.14.46-.2.73-.2.33 0 .61.1.83.32.28.27.42.66.42 1.19v2.15ZM89 11.25h-.89v1.74c0 .45.16.67.47.67.14 0 .26-.01.36-.04l.02.6a1.8 1.8 0 0 1-.62.1.95.95 0 0 1-.74-.3c-.18-.18-.27-.5-.27-.96v-1.81h-.53v-.6h.53v-.66l.78-.24v.9H89v.6ZM93.22 14.24h-.8V12.2c0-.64-.24-.97-.72-.97-.37 0-.62.19-.76.56a1 1 0 0 0-.04.3v2.15h-.8V9h.8v2.17h.02c.25-.4.6-.6 1.08-.6.33 0 .6.11.82.33.27.27.4.67.4 1.2v2.14ZM97.59 12.28c0 .14-.01.26-.03.36h-2.4c.01.35.13.62.35.81.2.17.46.25.78.25.36 0 .68-.05.97-.17l.13.56a3 3 0 0 1-1.21.22c-.56 0-1-.16-1.31-.5a1.81 1.81 0 0 1-.48-1.31c0-.54.15-1 .44-1.35.31-.39.73-.58 1.26-.58.52 0 .91.2 1.18.58.21.3.32.68.32 1.13Zm-.77-.21c.01-.24-.04-.44-.15-.61a.7.7 0 0 0-.64-.34c-.26 0-.47.11-.63.33a1.2 1.2 0 0 0-.24.62h1.66Z"/>
    </svg>
    <!-- eslint-enable -->
  </a>
</template>

<script>
import { getAdvertisingParamsFromSession } from 'Root/helpers/handleAdvertisingParams';
import { mapState } from 'vuex';

const SERVE_USER_BUTTON = '388453474360148239';
const SERVE_GUEST_BUTTON = '532774880660222202';

const SERVE_USER_FOOTER = '532568650339603323';
const SERVE_GUEST_FOOTER = '460511074991493582';

export default {
  name: 'AppstoreButton',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    isBig: {
      type: Boolean,
      required: false,
      default: false,
    },

    /**
     * Тип события для UTM
     */
    type: {
      type: String,
      default: 'button',
      validator: (value) => ['button', 'footer'].includes(value),
    },
  },

  data() {
    return {
      isSsr: true,
    };
  },

  computed: {
    ...mapState(['user']),

    href() {
      let SERVE;

      if (this.type === 'button') {
        SERVE = this.user ? SERVE_USER_BUTTON : SERVE_GUEST_BUTTON;
      } else {
        SERVE = this.user ? SERVE_USER_FOOTER : SERVE_GUEST_FOOTER;
      }

      const baseLink = `https://redirect.appmetrica.yandex.com/serve/${SERVE}`;
      let routePath;

      if (this.$route.path.includes('/client/orders/')) {
        routePath = '/client/orders/';
      } else {
        routePath = this.$route.path;
      }

      if (this.isSsr) {
        return `${baseLink}?placement=${routePath}`;
      }

      const UTM = getAdvertisingParamsFromSession();

      const utmParams = [
        'source',
        'medium',
        'campaign',
        'term',
        'placement',
        'content',
      ];

      const utmParts = [];

      utmParams.forEach((param) => {
        if (param in UTM) {
          utmParts.push(`utm_${param}=${UTM[param]}`);
        }
      });

      if (!utmParts.length) {
        utmParts.push('utm_source=skycoach.gg', 'utm_medium=website');
      }

      return `${baseLink}?${utmParts.join('&')}&placement=${routePath}`;
    },
  },

  beforeMount() {
    if (typeof window !== 'undefined') {
      this.isSsr = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.appstore__link {
  background: var(--background, $color--basic-black);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  min-width: 112px;
  border-radius: 4px;
  transition: var(--transition-color-bg);
}

.appstore__link--disabled {
  cursor: default;
  opacity: .5;
  pointer-events: none;
}

.appstore__img {
  color: var(--color, $color--basic-white);
  transition: var(--transition-color);
  width: 112px;
  height: 40px;
}

.appstore__img--big {
  width: 147px;
  height: 50px;
}
</style>
